// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"482":"d32b3944","633":"09445984"}[chunkId] + ".chunk.js";
};